import { useProjectContext } from "@contexts/projects";

// Resolve qual plano alimenta o IDP da obra ativa: linha de base congelada
// (indicator.idp) × previsto corrente da fonte canônica (indicator.idpForecast).
// O switch Base/Previsto só existe quando a obra tem os DOIS; com um só,
// o IDP usa o que houver, sem opção visível (decisão de produto 21/07/2026).
export const usePlanBasis = () => {
  const { activeProject, forecastBased } = useProjectContext();
  const indicator = activeProject?.indicator;

  const hasBase = Number.isFinite(indicator?.idp);
  const hasForecast = Number.isFinite(indicator?.idpForecast);
  const hasBothPlanBases = hasBase && hasForecast;

  let basis = null;
  if (hasBothPlanBases) basis = forecastBased ? "forecast" : "base";
  else if (hasForecast) basis = "forecast";
  else if (hasBase) basis = "base";

  return {
    hasBothPlanBases,
    basis,
    idpValue: basis === "forecast" ? indicator?.idpForecast : basis === "base" ? indicator?.idp : null,
  };
};
